import { render, staticRenderFns } from "./ComponentStaticDepartment.vue?vue&type=template&id=2fc21eb0&scoped=true"
import script from "./ComponentStaticDepartment.vue?vue&type=script&lang=js"
export * from "./ComponentStaticDepartment.vue?vue&type=script&lang=js"
import style0 from "./ComponentStaticDepartment.vue?vue&type=style&index=0&id=2fc21eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc21eb0",
  null
  
)

export default component.exports